<script setup lang="ts">
import CryptoWalletsContainer from './containers/CryptoWalletsContainer.vue'
</script>

<template>
  <CryptoWalletsContainer />
</template>
